import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DsnOperationMail } from 'app/models/dsn-operation-mail.model';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import { DivisionSalesNetworkService } from 'app/services/division-sales-network/divison-sales-network.service';
import { DsnOperationMailService } from 'app/services/dsn-operation-mail/dsn-operation-mail.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-dsn-operation-mail-form',
  templateUrl: './dsn-operation-mail-form.component.html',
  styleUrls: ['./dsn-operation-mail-form.component.css']
})
export class DsnOperationMailFormComponent implements OnInit, OnChanges {


  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxDsnOperationMail: DsnOperationMail;
  addEditForm: FormGroup;
  validationData = null;
  clusterItems: SelectItem[] = [];
  cluster: any;
  dsnItems: SelectItem[] = [];
  divisionSalesNetwork: any;
  serviceItems: SelectItem[] = [];
  service: any;
  validation: any;
  invalidSubmit: any;
  operationPidItems: any[] = [];
  operationPid: any;
  operationKey: string = null;
  email: string;
  validators = {
    emailOrEmpty: KoncentroValidators.emailOrEmpty,
  }
  flagService: boolean = false;
  flagCluster: boolean = false;

  constructor(
    private srvDsnOperationMail: DsnOperationMailService,
    private svcDivisionSalesNetwork: DivisionSalesNetworkService,
    private fb: FormBuilder,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.loadValidation();
    this.loadCombos();
  }

  ngOnChanges(): void {
    this.addEditForm = this.fb.group({
      'clusterId': new FormControl(this.dialogBoxDsnOperationMail.clusterId),
      'divisionSalesNetworkId': new FormControl(this.dialogBoxDsnOperationMail.divisionSalesNetworkId),
      'serviceId': new FormControl(this.dialogBoxDsnOperationMail.serviceId),
      'operationPid': new FormControl(this.dialogBoxDsnOperationMail.operationPid),
      'email': new FormControl(this.dialogBoxDsnOperationMail.email),
    });
  }

  loadValidation() {
    this.srvDsnOperationMail.getFields().subscribe(res => {
      this.validation = res
    })
  }

loadCombos() {
    this.cluster = this.dialogBoxDsnOperationMail.clusterId;
    this.operationPid = this.dialogBoxDsnOperationMail.operationPid;
    this.service = this.dialogBoxDsnOperationMail.serviceId;
    this.divisionSalesNetwork = this.dialogBoxDsnOperationMail.divisionSalesNetworkId;
    this.email = this.dialogBoxDsnOperationMail.email;

    this.getClusters();
    this.getDivisionSalesNetworks();
    this.getServices();
    this.getOperationPid();
  }

  getClusters() {
    this.srvDsnOperationMail.getClusters().subscribe(res => {
      this.clusterItems = [{label: '', value: null}];
      
      if (res && res.length > 0) {
        res.forEach(cluster => {
          this.clusterItems.push({ label: cluster.description, value: cluster.id });
        })

      }
    });
  }

  // getFilteredClusters(event) {
  //   this.clusterItems = [];
  //   this.srvDsnOperationMail.getFilteredClusters(event.query).subscribe((res) => {
  //     if(res && res.length > 0) {
  //       res.forEach(cluster => {
  //         this.clusterItems.push({label: cluster.code + ' - ' + cluster.description, value: cluster.id});
  //       })
  //      }
  //      console.log(this.clusterItems)
  //   });
  // }

  getDivisionSalesNetworks() {
    this.srvDsnOperationMail.getDivisionSalesNetwork().subscribe(res => {
      this.dsnItems = [{label: '', value: null}];

      if (res && res.length > 0) {
        res.forEach(dsn => {
          this.dsnItems.push({ label: dsn.div_sales_name, value: dsn.id });
        })

      }
    });
  }

  getServices() {
    this.srvDsnOperationMail.getServices().subscribe(res => {
      this.serviceItems = [{label: '', value: null}];
      
      if (res && res.length > 0) {
        res.forEach(service => {
          this.serviceItems.push({ label: service.name, value: service.id });
        })

      }
    });
  }

  getOperationPid() {
    this.srvDsnOperationMail.getOperationId().subscribe(res => {
      this.operationPidItems = [{label: '', value: null, key: null}];
      
      if (res && res.length > 0) {
        res.forEach(param => {
          this.operationPidItems.push({ label: this.translate.instant(`dsnOperationMailList.${param.param_code}`), value: param.id, key: param.param_key });
        })

        if(this.operationPid) {
          this.setOperation()
        }
      }
    });
  }

  saveOrUpdate() {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }

    if (!this.addEditForm.get('divisionSalesNetworkId').value && !this.addEditForm.get('operationPid').value && 
    !this.addEditForm.get('email').value) {
      this.invalidSubmit = true;
      return;
    }

    if((this.flagService && !this.addEditForm.get('serviceId').value) || 
    (this.flagCluster && !this.addEditForm.get('clusterId').value)) {
      this.invalidSubmit = true;
      return;
    }

    let newData = new DsnOperationMail();
    newData.id = this.dialogBoxDsnOperationMail.id;
    if (this.addEditForm.get('clusterId').value)
      newData.clusterId = this.addEditForm.get('clusterId').value;

    if (this.addEditForm.get('divisionSalesNetworkId').value)
      newData.divisionSalesNetworkId = this.addEditForm.get('divisionSalesNetworkId').value;

    if (this.addEditForm.get('serviceId').value)
      newData.serviceId = this.addEditForm.get('serviceId').value;

    if (this.addEditForm.get('operationPid').value)
      newData.operationPid = this.addEditForm.get('operationPid').value;
      
    if (this.addEditForm.get('email').value)
      newData.email = this.addEditForm.get('email').value;

    if (newData.id == null) {
      this.onAddElement.emit(newData);
    } else {
      this.onUpdateElement.emit(newData);
    }
  }

  setOperation() {
    this.operationKey = this.operationPidItems.find(operation => operation.value == this.operationPid).key
    if (this.operationKey == 'DOM.APPTABLET.SERVICE') {
      this.flagCluster = false;
      this.flagService = true;
      this.cluster = null;
    } else if (this.operationKey == 'DOM.APPTABLET.CLUSTER') {
      this.flagCluster = true;
      this.flagService = false;
      this.service = null;
    } else {
      this.flagCluster = false;
      this.flagService = false;
      this.cluster = null;
      this.service = null;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/views/administration/dsn-operation-mail/dsn-operation-mail-form/dsn-operation-mail-form.component.ts